import React from "react";

import { MuiTelInput, matchIsValidTel } from "mui-tel-input";
import { Controller } from "react-hook-form";

import ConnectForm from "./ConnectForm";
import { useSchool } from "../school/SchoolContext";

function PhoneInput({ namePrefix }) {
  const { phoneCountries, defaultPhoneCountry } = useSchool();

  // FIXME put in a service
  const name = (name) => {
    return namePrefix ? namePrefix + name : name;
  };

  return (
    <ConnectForm>
      {({ control }) => (
        <Controller
          name={name("phone")}
          control={control}
          rules={{ validate: matchIsValidTel, required: true }}
          render={({ field, fieldState }) => (
            <MuiTelInput
              {...field}
              required
              fullWidth
              id={name("phone")}
              variant="outlined"
              size="small"
              defaultCountry={defaultPhoneCountry}
              onlyCountries={phoneCountries}
              preferredCountries={phoneCountries}
              error={fieldState.invalid}
            />
          )}
        />
      )}
    </ConnectForm>
  );
}

export default PhoneInput;
